import { Directive } from '@angular/core';

@Directive({
  selector: '[app-table]',
  host: { class: 'border-separate border-spacing-y-0.5 w-full' },
})
export class TableDirective {}
